const ROLE_ADMIN_2 = 9;

export default {
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },

    isAdmin2() {
      const { user } = this.$store.state.user;
      return user?.settings?.role_id === ROLE_ADMIN_2;
    },

    canApproveOwnQuotation() {
      const { user } = this.$store.state.user;
      return !!user?.settings?.can_approve_own_quotation;
    },
  },
  methods: {
    canApproveQuotation(quotation) {
      if (this.isAdmin || this.isAdmin2) {
        return true;
      }
      if (!this.canApproveOwnQuotation || !quotation) {
        return false;
      }
      const { user } = this.$store.state.user;
      return Number(quotation.created_by) === Number(user.id);
    },
  },
};
